module.exports = __webpack_public_path__ + "static/media/lockie.7007e73d.png";